import { Color, parseColor255 } from '@fe/core';
import { ChartPosition, Rect } from '../../util';
import { Axis } from '../axis';
import { DrawPass } from '../chart';
import { ChartFeature, ShadeLayerSpecification, ShadeLineLayerSpecification } from '../chart-props';
import { getAxisRect } from '../helpers';

export function drawShadeLineLayer(pass: DrawPass, features: ChartFeature[], layer: ShadeLineLayerSpecification, xAxis: Axis, yAxis: Axis) {
    const axisRect = getAxisRect(ChartPosition.top, pass);
    const shadeRect = new Rect([axisRect.left, axisRect.bottom], { width: axisRect.width, height: 6 }).translate(0, -10);

    for (const feature of features) {
        if (feature.geometry.type === 'Shade') {
            pass.drawer.drawRect(shadeRect, {
                color: layer.paint.dayColor
            });
            const [r, g, b] = parseColor255(layer.paint.nightColor as string);
            pass.drawer.beginClip(shadeRect);
            pass.drawer.drawGradientRect(
                new Rect([pass.viewState.chartArea.left, shadeRect.top], { width: pass.viewState.chartArea.width, height: 6 }),
                feature.geometry.stops.map(([stop, level]) => [
                    Math.min(1, Math.max(0, xAxis.project(stop))),
                    `rgba(${r},${g},${b},${1.0 * level})` as Color
                ])
            );
            pass.drawer.endClip();
            pass.drawer.drawRect(
                shadeRect,
                {
                    color: '#00000000'
                },
                {
                    width: 0.5,
                    color: layer.paint.outlineColor
                }
            );
        }
    }
}

export function drawShadeLayer(pass: DrawPass, features: ChartFeature[], layer: ShadeLayerSpecification, xAxis: Axis, yAxis: Axis) {
    const color = parseColor255(layer.paint?.color ?? '#464646cc');
    for (const feature of features) {
        if (feature.geometry.type === 'Shade') {
            pass.drawer.drawGradientRect(
                pass.viewState.chartArea,
                feature.geometry.stops.map(([stop, level]) => [
                    Math.min(1, Math.max(0, xAxis.project(stop))),
                    `rgba(${color[0]},${color[1]},${color[2]},${((color[3] / 255) * level).toPrecision(2)})` as Color
                ])
            );
        }
    }
}
